import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f44e1df6")
const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-3 p-text-left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "assets/layout/images/login/icon-login.svg" })
], -1)
const _hoisted_7 = { class: "p-col-9 p-text-left" }
const _hoisted_8 = { class: "welcome-text" }
const _hoisted_9 = { class: "guest-sign-in" }
const _hoisted_10 = {
  key: 0,
  class: "message p-d-flex p-flex-column"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, " E' stata inviata un'email con il link e le istruzioni per il cambio della password.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mt-3" }, " Controllare la casella di posta per continuare la procedura. ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "message"
}
const _hoisted_15 = { class: "p-d-flex p-jc-center p-my-3" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createVNode(_component_AppLogo)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("h2", _hoisted_8, null, 512), [
            [_directive_t, 'lost_pwd.title']
          ]),
          _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
            [_directive_t, 'lost_pwd.subtitle']
          ])
        ])
      ]),
      (_ctx.emailSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
        : _createCommentVNode("", true),
      (!_ctx.emailSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Inserire l'email con cui si vuole procedere per il cambio della password "))
        : _createCommentVNode("", true),
      (!_ctx.emailSent)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)), ["prevent"])),
            class: "form mb-3",
            style: {"width":"95%"}
          }, [
            _createVNode(_component_FloatLabel, {
              label: "Email",
              class: "p-fluid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  required: "",
                  autofocus: "",
                  id: "email",
                  type: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Button, {
                type: "submit",
                label: "Invia email",
                icon: "pi pi-envelope"
              })
            ])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}